import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { loadCenters } from '../centers/actions';
import { loadUnpagedTerritories } from '../territories/actions';
import { joinCenterTerm } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation } from 'react-i18next';

class WeeklyPrograms extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleSelectTerm = this.handleSelectTerm.bind(this);
		this.handleShowNotification = this.handleShowNotification.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
		this.props.loadUnpagedTerritories();
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleSelectTerm(centerId, termId) {
		this.props.selectTerm(centerId, termId);
	}

	handleShowNotification(resourceMessage) {
		const t = this.props.t;
		toast.error(t(resourceMessage), { autoClose: 2000 });
	}

	render() {
		const { pagination, ...rest } = this.props;
		const { filter } = this.props.pagination;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} {...rest} initialValues={filter} loading={this.props.pagination.loading} />
				<List
					onFetchData={this.handleListEvent}
					onSelectTerm={this.handleSelectTerm}
					onShowNotification={this.handleShowNotification}
					enableSingleProgram={this.props.franchisor.enableSingleWeeklyProgram}
					{...pagination}
					{...rest}
				/>
				<ToastContainer theme='colored' />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { centers, territories, terms },
		configuration: { franchisor }, 
		auth: { currentUser },
		junction
	} = state;

	const centersPagignation = pagination.centers.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: centersPagignation.ids.map(id => centers[id]),
		terms: terms,
		territories,
		pagination: centersPagignation,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'WeeklyPrograms'),
		selectedTerms: junction.centerTermPrograms,
		franchisor
	};
};

const mapDispatchToProps = {
	loadEntities: loadCenters,
	loadUnpagedTerritories,
	selectTerm: joinCenterTerm,
	resetFilter: () => reset('weeklyProgramFilter')
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(WeeklyPrograms));